import { Divider } from "antd";

const Prolastin = () => {
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <Divider />
        <p className="m-2 font-bold">
          Important Safety Information
        </p>

        <p className="m-2">
          PROLASTIN®-C LIQUID is an alpha1-proteinase inhibitor (human) (alpha1-PI) indicated for chronic augmentation
          and maintenance therapy in adults with clinical evidence of emphysema due to severe hereditary deficiency of
          alpha1-PI (alpha1-antitrypsin deficiency).
        </p>

        <p className="m-2 font-bold underline">
          Limitations of Use
        </p>

        <p className="m-2 ml-10">The effect of augmentation therapy with any alpha1-PI, including PROLASTIN-C LIQUID, on
          pulmonary exacerbations and on the progression of emphysema in alpha1-PI deficiency has not been conclusively
          demonstrated in randomized, controlled clinical trials
        </p>

        <p className="m-2 ml-10">Clinical data demonstrating the long-term effects of chronic augmentation or
          maintenance therapy with PROLASTIN-C LIQUID are not available
        </p>

        <p className="m-2 ml-10">PROLASTIN-C LIQUID is not indicated as therapy for lung disease in patients in whom
          severe alpha1-PI deficiency has not been established
        </p>

        <p className="m-2">
          PROLASTIN-C LIQUID is contraindicated in immunoglobulin A (IgA)-deficient patients with antibodies against IgA
          or patients with a history of anaphylaxis or other severe systemic reaction to alpha1-PI products.
        </p>

        <p className="m-2">
          Hypersensitivity reactions, including anaphylaxis, may occur. Monitor vital signs and observe the patient carefully throughout the infusion. If hypersensitivity symptoms occur, promptly stop PROLASTIN-C LIQUID infusion and begin appropriate therapy.
        </p>

        <p className="m-2">
          Because PROLASTIN-C LIQUID is made from human plasma, it may carry a risk of transmitting infectious agents, eg, viruses, the variant Creutzfeldt-Jakob disease (vCJD) agent, and, theoretically, the Creutzfeldt-Jakob disease (CJD) agent. This also applies to unknown or emerging viruses and other pathogens.
        </p>

        <p className="m-2">
          The most common adverse reactions during PROLASTIN-C LIQUID clinical trials in >5% of subjects were diarrhea and fatigue, each of which occurred in 2 subjects (6%).
        </p>

        <div>
          <p className="m-2">
            <b>
              Please see&nbsp;
              <a
                target="_blank"
                href="/Ryplazim-Prescribing-Information.pdf"
                className="text-blue-500 hover:underline"
              >
                full Prescribing Information
              </a>
              &nbsp;for PROLASTIN-C LIQUID.
            </b>
          </p>
          <p className="m-2">
            <b>
              You are encouraged to report negative side effects of
              prescription drugs to the FDA. Visit&nbsp;
              <a
                target="_blank"
                href="http://www.fda.gov/medwatch"
                className="text-blue-500 hover:underline"
              >
                www.fda.gov/medwatch
              </a>
              &nbsp;or call 1-800-FDA-1088.
            </b>
          </p>
        </div>

      </div>
    </>
  );
};

export default Prolastin;
